import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

let lenisInstance: Lenis | null = null

export function initLenis(): Lenis {
  // Create Lenis instance
  lenisInstance = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    touchMultiplier: 2,
  })

  // Integrate Lenis with GSAP ScrollTrigger
  lenisInstance.on('scroll', ScrollTrigger.update)

  // Add Lenis to GSAP ticker for smooth animation
  gsap.ticker.add((time) => {
    lenisInstance?.raf(time * 1000)
  })

  // Disable GSAP lag smoothing for better sync with Lenis
  gsap.ticker.lagSmoothing(0)

  return lenisInstance
}

export function getLenis(): Lenis | null {
  return lenisInstance
}

export function stopLenis(): void {
  lenisInstance?.stop()
}

export function startLenis(): void {
  lenisInstance?.start()
}
